/* eslint-disable @typescript-eslint/dot-notation */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-use-before-define */
/* eslint-disable react/prop-types */

import { Badge, Pill } from "@mantine/core";
import { IconChevronsDown, IconChevronsUp } from "@tabler/icons-react";
import { ICellTextProps } from "ka-table/props";
import React from "react";
import TruncatedTextTooltip from "../ui/truncate/TruncatedText";

const MetricCell: React.FC<ICellTextProps> = React.memo(
  ({
    column, dispatch, rowKeyValue, ...props
  }) => {
    // Define gradient configurations based on delta value
    const value = props.rowData[`${column.key}`];
    let Icon;
    let color;
    
    if ((value?.delta) > 0 || value?.delta === null) {
      Icon = IconChevronsUp;
      color = "main.9";
    } else if ((value?.delta) < 0) {
      Icon = IconChevronsDown;
      color = "red.9";
    } else {
      color = "gray.9";
    }
    
    return (
      <span className="whitespace-nowrap relative capitalize w-full text-ellipsis overflow-hidden block px-2">
        <div className="flex items-center gap-2">
          <TruncatedTextTooltip size="sm" tooltipText={value?.value || "0"} width={100}>
            <span>{value?.value || "0"}</span>
          </TruncatedTextTooltip>
          <Badge
            color={color}
            size="sm"
            variant="light"
            autoContrast
            className="!py-0"
            classNames={{
              root: "!text-md",
            }}
          >
            {Icon ? <div className="flex items-center"><Icon className="mr-1 w-3 h-3" />{value?.delta === null ? "∞" : `${value?.delta} %`}</div> : (value?.delta === null ? "∞" : `${value?.delta} %`)}
          </Badge>
        </div>
      </span>
    );
  },
);

export default MetricCell;
